import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Invoices.types'

@Injectable({ providedIn: 'root' })
export class Invoices_invoicing_mainService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { instructionId?: string, instructionName?: string, output?: boolean, projectIdsToInclude?: number[], projectIdsToExclude?: number[] }): Promise<{ messages?: any[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/functions/invoicing_main`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

